<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="证书号"><el-input v-model="query.certNo" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('plm:plmCompliance:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('plm:plmCompliance:save')" type="primary" size="small" @click="open()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="code" label="证书编号" min-width="120" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('plm:plmCompliance:info') || isAuth('plm:plmCompliance:update')" class="code-link" @click="open(scope.row)">{{ scope.row.code }}</a>
          <span v-else>{{ scope.row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="certType" label="证书类型" min-width="100" header-align="center" align="left" />
      <el-table-column prop="status" label="状态" width="90" header-align="center" align="center" />
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />

    <el-dialog :title="form.id ? '修改合规证书' : '新增合规证书'" :visible.sync="visible" width="min(560px, calc(100vw - 24px))" :close-on-click-modal="false">
      <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="证书编号" prop="certNo"><el-input v-model="form.certNo" /></el-form-item>
        <el-form-item label="证书类型"><el-input v-model="form.certType" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button v-if="form.id && (isAuth('plm:plmCompliance:delete') || isAuth('plm:plmCompliance:save'))" type="danger" @click="remove">删除</el-button>
        <el-button v-if="form.id ? (isAuth('plm:plmCompliance:update') || isAuth('plm:plmCompliance:save')) : isAuth('plm:plmCompliance:save')" type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  name: 'PlmCompliance',
  data() {
    return {
      query: { certNo: '' },
      list: [], pageIndex: 1, pageSize: 10, loading: false, visible: false, permCodes: [], form: {},
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' },
      rules: { certNo: [{ required: true, message: '证书号不能为空', trigger: 'blur' }] }
    }
  },
  computed: {
    filtered() { return this.list.filter(row => this.has(row.code, this.query.certNo)) },
    total() { return this.filtered.length },
    pageList() { return this.filtered.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    has(value, keyword) {
      const text = String(keyword || '').trim().toLowerCase()
      if (!text) return true
      return String(value || '').toLowerCase().indexOf(text) >= 0
    },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.get('/plm/cert/list').then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    },
    open(row) {
      this.visible = true
      const blank = () => ({ id: '', certNo: '', certType: '', remark: '' })
      if (!row || !row.id) {
        this.form = blank()
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
        return
      }
      request.get('/plm/cert/info', { params: { id: row.id } }).then(res => {
        const data = res.data || {}
        this.form = { id: data.id || row.id, certNo: data.certNo || data.code || row.code || '', certType: data.certType || row.certType || '', remark: data.remark || '' }
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      }).catch(() => {
        this.form = { id: row.id, certNo: row.code || '', certType: row.certType || '', remark: row.remark || '' }
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      })
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        request.post('/plm/cert/save', { id: this.form.id, certNo: this.form.certNo, certType: this.form.certType, remark: this.form.remark })
          .then(() => { this.$message.success('保存成功'); this.visible = false; this.load() }).catch(() => {})
      })
    },
    remove() {
      if (!this.form.id) return
      this.$confirm('确定删除该合规证书?', '提示', { type: 'warning' }).then(() => {
        request.post('/plm/cert/delete', { id: this.form.id }).then(() => {
          this.$message.success('删除成功'); this.visible = false; this.load()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
</style>
